var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ScIcon",
    d: "M9,9.75a1.5,1.5,0,0,0-1.5-1.5H6.75a3,3,0,0,0-3,3V13.5a3,3,0,0,0,3,3H7.5A1.5,1.5,0,0,0,9,15Zm8.25,6.75a3,3,0,0,0,3-3V11.25a3,3,0,0,0-3-3H16.5A1.5,1.5,0,0,0,15,9.75V15a1.5,1.5,0,0,0,1.5,1.5ZM12,0A12.228,12.228,0,0,0,0,12v.75a.75.75,0,0,0,.75.75H1.5a.75.75,0,0,0,.75-.75V12a9.75,9.75,0,0,1,19.5,0h-.006c0,.114.006,7.768.006,7.768a1.982,1.982,0,0,1-1.982,1.982H15a2.25,2.25,0,0,0-2.25-2.25h-1.5a2.25,2.25,0,0,0,0,4.5h8.518A4.232,4.232,0,0,0,24,19.768V12A12.228,12.228,0,0,0,12,0Z",
    fill: "#414042"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScIcon);
export default __webpack_public_path__ + "static/media/ScIcon.0cd9ff7dc928e0d8aedfef1e8d01a6ab.svg";
export { ForwardRef as ReactComponent };